import React, {useMemo, useState, createContext} from 'react';

export const LocalDirtyContext = createContext();

export const LocalDirtyProvider = ({children}) => {
  const [localDirtyBlocks, setLocalDirtyBlocks] = useState([]);
  const value = useMemo(() => [localDirtyBlocks, setLocalDirtyBlocks], [localDirtyBlocks]);

  return (
    <LocalDirtyContext.Provider value={value}>
      {children}
    </LocalDirtyContext.Provider>
  );
};
